"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HSVtoRGB = HSVtoRGB;
exports.getUserColor = void 0;
function HSVtoRGB(h, s, v) {
  var r, g, b;
  var i = Math.floor(h * 6);
  var f = h * 6 - i;
  var p = v * (1 - s);
  var q = v * (1 - f * s);
  var t = v * (1 - (1 - f) * s);
  switch (i % 6) {
    case 0:
      r = v, g = t, b = p;
      break;
    case 1:
      r = q, g = v, b = p;
      break;
    case 2:
      r = p, g = v, b = t;
      break;
    case 3:
      r = p, g = q, b = v;
      break;
    case 4:
      r = t, g = p, b = v;
      break;
    default:
      r = v, g = p, b = q;
  }
  return {
    r: Math.round(r * 255),
    g: Math.round(g * 255),
    b: Math.round(b * 255)
  };
}
function generateRGB(hue) {
  return HSVtoRGB(hue, 0.5, 0.95);
}
var getUserColor = exports.getUserColor = function getUserColor(userId) {
  var decValues = [];
  var hue = 0.71; //default value yields globey purple
  //we're expecting a mongo ObjectId
  if (userId && userId.length === 24) {
    var hexValues = userId.slice(21, 24).split('');
    hexValues.forEach(function (hexValue) {
      var decValue = parseInt(hexValue, 16);
      if (decValue >= 1) {
        decValues.push(decValue);
      } else {
        decValues.push(1);
      }
    });
    var a = decValues[0],
      b = decValues[1],
      c = decValues[2];
    var nextValue = a * b * c;
    hue = nextValue / Math.pow(10, nextValue.toString().length);
  }
  var rgb = generateRGB(hue);
  return rgb;
};